import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";

const SeasonalRecruitment = () => {
  const { t } = useTranslation();
  return (
    <div className="page-title">
      <h1>صفحة التوظيف الموسمي الرئيسية</h1>
      <Container fluid>{t("WELCOME_SEASONAL_RECRUITMENT_DASHBOARD")}</Container>
    </div>
  );
};

export default SeasonalRecruitment;
